import { triggerAnalytics } from './analytics-utils';

export default class OverlayEvents {
  // 7.39.2 Welcome to the Path to Pro Network Overlay
  welcomeMessage = () => {
    triggerAnalytics('pathToProNetwork.welcome.overlay');
  };
}
